import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import uniqueId from 'lodash/uniqueId';
import map from 'lodash/map';
import * as Spinners from '@Services/Spinners';
import RxSpinnerComponent from '@Components/Results/utils/rx-spinner.component';
import externalUrl from '@Utils/ExternalUrl';
import ChemQuoteProviderComponent from '@Components/Results/structure/availability/chemquote-provider.component';
import CommercialSubstancesProviderComponent from '@Components/Results/structure/availability/commercial-substances-provider.component';
import { ButtonWithIcon } from '@els/els-react--button';

export default class AvailabilityProvidersComponent extends React.Component {
  constructor(props) {
    super(props);

    this.spinnerId = uniqueId('shopping-cart-');

    this.state = { providers: [], providersLoaded: false };
  }

  componentDidMount() {
    const { providersArePreload } = this.props;
    if (!providersArePreload) {
      return;
    }
    Spinners.activate(this.spinnerId);
    this.loadProviders().finally(() => Spinners.terminate(this.spinnerId));
  }

  componentDidUpdate(prevProps) {
    const { isOpen: prevIsOpen } = prevProps;
    const { isOpen, providersArePreload } = this.props;

    if (!providersArePreload && isOpen && prevIsOpen !== isOpen) {
      Spinners.activate(this.spinnerId);
      this.loadProviders().finally(() => Spinners.terminate(this.spinnerId));
    }
  }

  loadProviders() {
    const { providers, loadImage } = this.props;
    const promises = map(providers, loadImage);
    return (
      Promise.all(promises)
        // eslint-disable-next-line no-shadow
        .then((providers) => this.setState({ providers, providersLoaded: true }))
        .catch(Logger.error)
    );
  }

  providerClickHandler(event, provider) {
    const { onProviderClick, closeMenu } = this.props;
    event.preventDefault();
    onProviderClick(provider.label);

    if (provider.linkUrl) {
      window.open(externalUrl(provider.linkUrl), '_blank');
    }
    closeMenu();
  }

  render() {
    const { className, structure, closeMenu, onProviderClick } = this.props;
    const { providers, providersLoaded } = this.state;
    return (
      <div className={cn('availability-providers', className)}>
        <div className="availability-providers--spinner-container">
          <RxSpinnerComponent spinnerId={this.spinnerId} spinnerClass="availability-providers--spinner" spinnerScale={1} />
        </div>

        {providersLoaded ? (
          <table className="commercial-availability">
            <tbody>
              <CommercialSubstancesProviderComponent structure={structure} closeMenu={closeMenu} onClick={() => onProviderClick('rcs')} />
              <ChemQuoteProviderComponent
                closeMenu={closeMenu}
                providers={providers}
                structure={structure}
                onClick={() => onProviderClick('chemquote')}
              />
              {providers.map((provider, index) =>
                provider.show ? (
                  // eslint-disable-next-line react/no-array-index-key
                  <tr key={index} role="menuitem">
                    <td className="column-provider-logo">
                      <img className="provider-image" src={provider.imageUrl} alt={provider.label} />
                    </td>
                    <td>
                      <ButtonWithIcon
                        className={cn('provider-link', `e2e-shopping-cart-${provider.label}`)}
                        sprite="UpRight"
                        iconRight
                        type="link"
                        linkIconSize="xs"
                        onClick={(event) => this.providerClickHandler(event, provider)}>
                        {provider.label}
                      </ButtonWithIcon>
                    </td>
                  </tr>
                ) : null
              )}
            </tbody>
          </table>
        ) : null}
      </div>
    );
  }
}

AvailabilityProvidersComponent.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  providers: [],
  onProviderClick: () => null,
};

AvailabilityProvidersComponent.propTypes = {
  providers: PropTypes.array.isRequired,
  loadImage: PropTypes.func.isRequired,
  closeMenu: PropTypes.func.isRequired,
  structure: PropTypes.object.isRequired,
  className: PropTypes.string,
  onProviderClick: PropTypes.func,
  isOpen: PropTypes.bool,
  providersArePreload: PropTypes.bool,
};
